
export class Personnel {
    matricule:any;
    nom :any;
    prenom:any;
    fonction:any;
    mail:any;
    tel:any;

    lieu:any;
    etat:any;
    specialite:any;
    id_pers:any;

    constructor( id_pers:any){
      
    }
}
